var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-fluid",
    attrs: {
      "id": "home"
    }
  }, [_c('HomeHeader'), _c('Slide'), _c('div', {
    staticClass: "content-part hide bg-white",
    attrs: {
      "id": "somos"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Nuestra Empresa")]), _c('h5', {
    staticClass: "content-subtitle"
  }, [_vm._v("Lema o eslogan de la empresa aqui")]), _c('p', {
    staticClass: "content-text"
  }, [_vm._v(_vm._s(_vm.company.description))]), _c('div', {
    staticClass: "row sub-row",
    attrs: {
      "id": "beneficios"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(0), _c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Económico")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(1), _c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Rápido")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(2), _c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Calidad")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])])])]), _c('div', {
    staticClass: "content-part bg-gray",
    attrs: {
      "id": "servicios"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Escoge tu servicio")]), _c('h5', {
    staticClass: "content-subtitle"
  }, [_vm._v("Descubre los Servicios Que tenemos para ti")]), _c('HomeServices')], 1), _vm._m(3), _c('div', {
    staticClass: "content-part",
    attrs: {
      "id": "noticias"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Noticias")]), _c('h5', {
    staticClass: "content-subtitle"
  }, [_vm._v("Informaciones para clientes")]), _c('div', {
    staticClass: "row sub-row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Noticia 1")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Noticia 2")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])])])]), _c('div', {
    staticClass: "content-part bg-gray",
    attrs: {
      "id": "contactanos"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Visitanos")]), _c('HomeMap')], 1), _vm._m(4), _c('MessageBox'), _c('HomeFooter')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-image-container animated-pulse"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_money")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-image-container animated-pulse"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("flash_on")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-image-container animated-pulse"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dns")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "comercial"
    }
  }, [_c('div', {
    staticClass: "content-part cover bg-contrast"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Se parte de nosotros")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Selecciona el servicio que prefieras y contactanos.")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "horarios"
    }
  }, [_c('div', {
    staticClass: "content-part cover custom-bg-primary"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Horarios")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Lunes a Viernes: 9:00 am - 5:00 pm.")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Sabados: 9:00 am - 12:00 pm.")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Domingo: No laboramos")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3492b80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/src/modules/home/Home.vue
// module id = 48
// module chunks = 0